import axios from "axios";

class RegisterCharity {
  constructor() {
    //=======================
    //Register charity page
    //=======================
    if (document.querySelector(".register-charities-page")) {
      this.registerByDate = document.querySelector(".register-date-button");
    }
    this.events();
  }

  events() {
    //=======================
    //Register charity page Event
    //=======================
    if (document.querySelector(".register-charities-page")) {
      this.registerByDate.addEventListener("click", () =>
        this.registerByDateCharities()
      );
    }
  }

  async registerByDateCharities() {
    try {
      document.querySelector(".register-by-date-results").innerHTML = "";
      document.querySelector(".date-results-loader").style.visibility =
        "visible";
      const startDate = document.getElementById("input-start-date").value;
      const endDate = document.getElementById("input-end-date").value;
      let limitCharitiesNumber;
      if (document.getElementById("limit-charities-number").value) {
        limitCharitiesNumber = document.getElementById(
          "limit-charities-number"
        ).value;
      }
      console.log(
        charitiesData.root_url +
          "/wp-json/charity/v1/register-charity/?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "$limitNumber=" +
          limitCharitiesNumber
      );
      const response = await axios.post(
        charitiesData.root_url +
          "/wp-json/charity/v1/register-charity/?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&limitNumber=" +
          limitCharitiesNumber
      );
      const results = response.data;

      console.log("results");
      console.log(results);

      if (results && typeof results === "object") {
        document.querySelector(".date-results-loader").style.visibility =
          "hidden";
        document.querySelector(".register-by-date-results").innerHTML = `
          <h4>Charities to create: ${results.charitiesToCreate}</h4>
        
          <h4>Charities not created: ${results.charitiesNotCreated}</h4>
          <h4>List of charities not created:</h4>
          ${results.listCharitiesNotCreated
            .map(
              (charity) => `
              <p>${charity.charity_name} - ${charity.charity_number}</p>
            `
            )
            .join("")}
        `;
      } else {
        document.querySelector(".date-results-loader").style.visibility =
          "hidden";
        document.querySelector(".register-by-date-results").innerHTML = `
          <h4>${results}</h4>
        `;
      }
    } catch (e) {
      console.log(e);
      return e;
    }
  }
}

export default RegisterCharity;
